import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RoofMaterialTypeRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: RoofMaterialTypeRow[];
  loading?: boolean;
};

const RoofMaterialTypeTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "materialTypeId",
        label: t("ROOF_MATERIAL_TYPE.TABLE.NUMBER"),
        align: "right",
        width: "56px",
        minWidth: "56px",
        format: (row: RoofMaterialTypeRow) => (
          <span className={styles.numberCell}>{row.materialTypeId}</span>
        ),
      },
      {
        id: "materialTypeDesc",
        label: t("ROOF_MATERIAL_TYPE.TABLE.DESCRIPTION"),
        align: "right",
        format: (row: RoofMaterialTypeRow) => (
          <span className={styles.textCell}>{row.materialTypeDesc}</span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("ROOF_MATERIAL_TYPE.EMPTY")}
      />
    </div>
  );
};

export default RoofMaterialTypeTable;
